var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: !_vm.hidden,
          expression: "!hidden",
        },
      ],
      staticClass: "input grid__cell",
      class: _vm.inputClasses,
    },
    [
      _c("div", { staticClass: "input--checkbox" }, [
        _c("p", { staticClass: "text-small blueDark mg mg--b-2" }, [
          _vm._v(_vm._s(_vm.$t(_vm.literal))),
        ]),
        _c(
          "ul",
          { staticClass: "input__wrapper" },
          _vm._l(_vm.options, function (option) {
            return _c("li", [
              _c("label", [
                _c("p", { staticClass: "text-medium black" }, [
                  _vm._v(_vm._s(_vm.$t(option.literal))),
                ]),
                _c("input", {
                  attrs: { type: "checkbox", for: _vm.name, name: _vm.name },
                  domProps: {
                    value: option.key,
                    checked: _vm.isChecked(option.key),
                  },
                  on: { change: _vm.handleCheckboxClick },
                }),
                _c("span", { staticClass: "checkmark" }),
              ]),
            ])
          }),
          0
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }